import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import APIcon from "./buttons/APIcon";

const APInfoText = ({ text }: { text: string }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "start", gap: 1 }}>
      <Box sx={{ mt: "2px" }}>
        <APIcon name="info" size="small" color="primary" />
      </Box>
      <Typography
        sx={{ whiteSpace: "pre-line" }}
        variant="labelLarge"
        color="secondary"
      >
        {text}
      </Typography>
    </Box>
  );
};

export default APInfoText;
